<template>
  <div :id="name">
    <div class="action-part">
      <el-button @click="showEditor(null)" type="primary" size="medium">创建分类</el-button>
    </div>
    <div class="content-list">
      <el-table
          border
          :data="resultList"
          style="width: 100%">
        <el-table-column
            prop="name"
            label="分类名称"
            width="250">
        </el-table-column>
        <el-table-column
            prop="ord"
            label="排序"
            align="center"
            width="180">
        </el-table-column>
        <el-table-column
            width="180"
            align="center"
            label="是否可用">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.enable" active-value="1" inactive-value="0"
                       @change="onItemEnableChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column
            prop="count"
            width="180"
            align="center"
            label="内容数量">
        </el-table-column>
        <el-table-column
            width="180"
            align="center"
            label="消耗石头">
          <template slot-scope="scope">
            <span style="color: green " v-if="scope.row.payWith==='1'">{{ scope.row.price }} (绿色石头)</span>
            <span style="color: blue" v-if="scope.row.payWith==='2'">{{ scope.row.price }} (蓝色石头)</span>
            <span style="color: red" v-if="scope.row.payWith==='3'">{{ scope.row.price }} (红色石头)</span>
            <span style="color: #fafa03" v-if="scope.row.payWith==='4'">{{ scope.row.price }} (黄色石头)</span>
            <span style="color: #4EC9B0" v-if="scope.row.payWith==='5'">{{ scope.row.price }} (青色石头)</span>
            <span style="color: orange" v-if="scope.row.payWith==='6'">{{ scope.row.price }} (橙色石头)</span>
            <span style="color: #5c2699" v-if="scope.row.payWith==='7'">{{ scope.row.price }} (紫色石头)</span>
            <span v-if="scope.row.payWith===null || scope.row.payWith==='0'">免费</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="createTime"
            label="创建时间">
        </el-table-column>
        <el-table-column
            align="center"
            width="300"
            label="操作">
          <template slot-scope="scope">
            <el-button type="info" size="medium" @click="toStoryPage(scope.row)">故事</el-button>
            <el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='马上删除'
                cancel-button-text='我后悔了'
                icon="el-icon-info"
                @confirm="deleteItem(scope.row)"
                icon-color="red"
                title="确定删除该分类吗？">
              <el-button slot="reference" type="danger" style="margin-left: 10px;" size="medium">
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-part">
      <el-dialog
          :title="dialogText"
          :visible.sync="isEditorShow"
          width="400px"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          center>
        <div class="dialog-content">
          <el-form :inline="true" size="medium">
<!--            <el-form-item label="模块" :required="true">-->
<!--              <el-cascader-->
<!--                  clearable-->
<!--                  v-model="selectModuleIds"-->
<!--                  :options="appModuleTreeData"-->
<!--                  :props="{ checkStrictly: true, value: 'id', label: 'name' }"-->
<!--                  :show-all-levels="true"-->
<!--                  @change="() => {}" placeholder="请选择数据的模块"></el-cascader>-->
<!--            </el-form-item>-->
            <el-form-item label="名称" :required="true">
              <el-input placeholder="请输入分类名称" v-model="category.name"></el-input>
            </el-form-item>
            <el-form-item label="排序" :required="true">
              <el-input-number v-model="category.ord" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="可用" :required="true">
              <el-switch v-model="category.enable" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="石头" :required="true">
              <el-select v-model="category.payWith">
                <el-option value="0" label="免费"></el-option>
                <el-option value="1" label="绿色石头"></el-option>
                <el-option value="2" label="蓝色石头"></el-option>
                <el-option value="3" label="红色石头"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单价" :required="true" v-if="category.payWith!==null&&category.payWith!=='0'">
              <el-input-number v-model="category.price" :min="1"></el-input-number>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
                   <el-button @click="onEditorCancel" size="medium">取 消</el-button>
                   <el-button type="primary" @click="onEditorConfirm" size="medium">提 交</el-button>
                </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'

export default {
  data() {
    return {
      name: 'sleep-category',
      category: {
        id: '',
        name: '',
        moduleId: '0',
        ord: 0,
        enable: '1',
        payWith: '0',
        price: 0
      },
      selectModuleIds: [],
      appModuleTreeData: [],
      isEditorShow: false,
      dialogText: '',
      resultList: []
    }
  },
  methods: {
    toStoryPage(item) {
      let categoryId = item.id;
      this.$router.push({
        path: '/sleep/story',
        query: {
          categoryId: categoryId
        }
      })
    },
    onItemEnableChange(item) {
      api.putSleepCategory(item).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success("更新状态成功.")
        } else {
          this.$message.error("更新状态失败.")
        }
      })
    },
    deleteItem(item) {
      let id = item.id;
      api.deleteStoryCategory(id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.listContent();
          this.$message.success(result.msg)
        } else {
          this.$message.error(result.msg)
        }
      })
    },
    showEditor(item) {
      this.selectModuleIds = [];
      if (item) {
        this.dialogText = '编辑分类';
        this.category.id = item.id;
        this.category.name = item.name;
        this.category.ord = item.ord;
        this.category.enable = item.enable;
        this.category.moduleId = item.moduleId;
        this.selectModuleIds.push(item.moduleId)
      } else {
        this.dialogText = '创建分类';
      }
      this.isEditorShow = true;
    },
    listContent() {
      api.listStoryCategories().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.resultList = result.data;
        }
      })
    },
    onEditorConfirm() {
      this.category.moduleId = this.selectModuleIds[this.selectModuleIds.length - 1];
      //检查数据
      if (this.category.name === '') {
        return this.$message.error("分类名称不可以为空.");
      }
      if (this.category.id === '') {
        api.postSleepCategory(this.category).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.listContent();
            this.onEditorCancel();
            this.$message.success(result.msg);
          } else {
            this.$message.error(result.msg);
          }
        });
      } else {
        api.putSleepCategory(this.category).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.listContent();
            this.onEditorCancel();
            this.$message.success(result.msg);
          } else {
            this.$message.error(result.msg);
          }
        });
      }
    },
    onEditorCancel() {
      this.category.enable = '1';
      this.category.ord = 0;
      this.category.name = '';
      this.category.id = '';
      this.isEditorShow = false;
    },

    getModuleTreeData() {
      api.getAppModuleTree().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.appModuleTreeData = result.data;
        }
      })
    },
  },
  mounted() {
    this.listContent();
    this.getModuleTreeData();
  }
}
</script>
<style>
.content-list {
  margin-bottom: 20px;
  margin-top: 20px;
}

</style>
